import qs from 'query-string';
import { axiosBeelineRequest } from '@beef/utils';
import { CART_API_URL, CART_REGION_URL } from "./consts";
export var getAllRegions = function getAllRegions() {
  var culture = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'RU';
  return axiosBeelineRequest({
    method: 'post',
    url: '/region/regionsList/',
    data: {
      clearJson: 'true'
    },
    headers: {
      'Content-Type': 'application/json'
    },
    params: {
      'ui-culture': culture === 'RU' ? 'ru-ru' : 'en-us'
    }
  });
};
export var getCartRegions = function getCartRegions() {
  return axiosBeelineRequest({
    method: 'get',
    url: "".concat(CART_API_URL, "/").concat(CART_REGION_URL),
    headers: {
      'Content-Type': 'application/json'
    }
  });
};
export var getSuggestionsRegions = function getSuggestionsRegions(startsWith) {
  var culture = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'RU';
  return axiosBeelineRequest({
    method: 'post',
    url: '/region/getsuggestions/',
    data: {
      clearJson: 'true'
    },
    headers: {
      'Content-Type': 'application/json'
    },
    params: {
      'ui-culture': culture === 'RU' ? 'ru-ru' : 'en-us',
      startsWith: startsWith
    }
  });
};
var getRegionFromUrl = function getRegionFromUrl() {
  return window.location.hostname.split('.')[0];
};
export var changeRegion = function changeRegion(region) {
  var culture = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'RU';
  var redirectToNewRegion = function redirectToNewRegion() {
    window.location.href = window.location.href.replace(getRegionFromUrl(), region.id);
  };
  var paramsString = qs.stringify({
    regionName: region.id,
    cultureName: culture === 'RU' ? 'ru-ru' : 'en-us',
    customCity: region.customCity,
    lat: region.lat,
    lon: region.lon,
    custom: 'async'
  });
  axiosBeelineRequest({
    method: 'post',
    url: "/region/change?".concat(paramsString),
    data: {
      path: window.location.href
    },
    headers: {
      'Content-Type': 'application/json'
    }
  }).catch(function (e) {
    console.error(e);
  }).finally(redirectToNewRegion);
};
export var approveRegion = function approveRegion(userRegion) {
  axiosBeelineRequest({
    method: 'post',
    url: '/region/confirmregion',
    data: {
      regionName: userRegion.code
    },
    headers: {
      'Content-Type': 'application/json'
    }
  }).catch(console.error);
};